import Vue from 'vue'
import VueRouter from 'vue-router'
import {initialView} from './param'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      name: 'view',
      path: '/view/:id',
      component: () => import(/* webpackChunkName: 'App' */'./App.vue'),
      props: route => ({ id: Number(route.params.id) }),
    },
    {
      path: '/view',
      redirect: `/view/${initialView}`,
//      redirect: '/view/28'
    },
    {
      path: '/top',
      component: () => import(/* webpackChunkName: 'Top' */'./Top.vue'),
    },
    {
      path: '*',
      redirect: '/top'
    }
  ],
})
